import React from 'react';
import {
  FaTimes,
  FaStar,
  FaCheckCircle,
  FaBan,
  FaTrash,
  FaCalendar,
  FaMapMarkerAlt,
} from 'react-icons/fa';

const AdminReviewDetailModal = ({
  review,
  onClose,
  onApprove,
  onReject,
  onDelete,
  actionLoading,
}) => {
  if (!review) return null;

  const renderStars = (rating) =>
    Array.from({ length: 5 }, (_, i) => (
      <FaStar
        key={i}
        className={i < Math.floor(rating) ? 'adm-rev-modal-star-filled' : 'adm-rev-modal-star-empty'}
      />
    ));

  const isLoading = actionLoading === review.id;

  return (
    <div className="adm-rev-modal-overlay" onClick={onClose}>
      <div className="adm-rev-modal-content" onClick={(e) => e.stopPropagation()}>

        {/* Header */}
        <div className="adm-rev-modal-header">
          <div>
            <h2>Review Details</h2>
            <p>{review.review_id}</p>
          </div>
          <button className="adm-rev-modal-close" onClick={onClose}>
            <FaTimes />
          </button>
        </div>

        <div className="adm-rev-modal-body">

          <div className="adm-rev-modal-section">
            <h3>Customer Information</h3>
            <div className="adm-rev-modal-info-grid">
              <div className="adm-rev-modal-info-item">
                <label>Name</label>
                <span>{review.jjbooking?.jjcustomer?.cus_username}</span>
              </div>
              <div className="adm-rev-modal-info-item">
                <label>Email</label>
                <span>{review.jjbooking?.jjcustomer?.cus_email}</span>
              </div>
              <div className="adm-rev-modal-info-item">
                <label>User ID</label>
                <span>CUS-{review.jjbooking?.jjcustomer_id}</span>
              </div>
              <div className="adm-rev-modal-info-item">
                <label>Booking ID</label>
                <span>BOO-{review.jjbooking_id}</span>
              </div>
            </div>
          </div>

          <div className="adm-rev-modal-section">
            <h3>Reviewed Item</h3>
            <div className="adm-rev-modal-item-card">
              <span className={`adm-rev-type-badge adm-rev-type-${review.jjbooking?.booking_type}`}>
  {review.jjbooking?.booking_type}
</span>
    
            </div>
          </div>

          <div className="adm-rev-modal-section">
            <h3>Rating</h3>
            <div className="adm-rev-modal-rating-display">
              <div className="adm-rev-modal-rating-stars">{renderStars(review.rating)}</div>
              <span className="adm-rev-modal-rating-value">{review.rating} / 5.0</span>
            </div>
          </div>

          <div className="adm-rev-modal-section">
            <h3>Review Message</h3>
            <div className="adm-rev-modal-review-content">
              <p>{review.review_message}</p>
            </div>
          </div>

{review.image && (
  <div className="adm-rev-modal-section">
    <h3>Attached Image</h3>
    <div className="adm-rev-modal-image">
      <img
        src={`http://localhost:8000/storage/${review.image}`}
        alt="Review"
        style={{ width: '10' , height:'20'}}
        onError={(e) => {
          e.target.src = 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=600';
        }}
      />
    </div>
  </div>
)}

          <div className="adm-rev-modal-section">
            <h3>Status Information</h3>
            <div className="adm-rev-modal-info-grid">
              <div className="adm-rev-modal-info-item">
                <label>Status</label>
                <span className={`adm-rev-status-badge adm-rev-status-${review.status}`}>
                  {review.status}
                </span>
              </div>
              <div className="adm-rev-modal-info-item">
                <label>Submitted</label>
                <span>{new Date(review.created_at).toLocaleString()}</span>
              </div>
              {review.updated_at && (
                <div className="adm-rev-modal-info-item">
                  <label>Last Updated</label>
                  <span>{new Date(review.updated_at).toLocaleString()}</span>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="adm-rev-modal-footer">
          <button className="adm-rev-modal-btn adm-rev-modal-btn-secondary" onClick={onClose}>
            Close
          </button>

          {review.status === 'pending' && (
            <>
              <button
                className="adm-rev-modal-btn adm-rev-modal-btn-success"
                disabled={isLoading}
                onClick={() => onApprove(review.id)}
              >
                <FaCheckCircle /> {isLoading ? 'Processing...' : 'Approve'}
              </button>
              <button
                className="adm-rev-modal-btn adm-rev-modal-btn-danger"
                disabled={isLoading}
                onClick={() => onReject(review.id)}
              >
                <FaBan /> {isLoading ? 'Processing...' : 'Reject'}
              </button>
            </>
          )}

          <button
            className="adm-rev-modal-btn adm-rev-modal-btn-delete"
            disabled={isLoading}
            onClick={() => onDelete(review.id)}
          >
            <FaTrash /> {isLoading ? 'Processing...' : 'Delete'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminReviewDetailModal;